/**
 * Hairo's mark: the animated Hairo sphere, everywhere it appears (Ask Hairo
 * floating launcher, the panel, message avatars, AI job posting, and the
 * interviewer panel of the jobseeker interview screens).
 *
 * The same animation as the original 3.2 MB WebP, re-encoded at 240 px (it is
 * never shown larger than 120 px, so that is sharp on 2x screens) and 12 fps:
 * 339 KB, one file, cached after the first load. A vector SVG was tried and
 * looked cartoonish next to the rendered glow, so it stays a raster.
 *
 * `size` sets width and height in px; pass `size={null}` to size it from CSS
 * instead (the AI posting hero shrinks it on scroll). Decorative, so hidden
 * from assistive tech.
 */

import hairoOrb from "../../assets/images/HairoOrb.webp";

export default function HairoOrb({ size = 32, className = "" }) {
  const sized = size == null ? undefined : { width: size, height: size };
  return (
    <img
      src={hairoOrb}
      alt=""
      aria-hidden="true"
      width={size ?? undefined}
      height={size ?? undefined}
      decoding="async"
      draggable={false}
      className={`hairo-orb-img ${className}`.trim()}
      style={sized}
    />
  );
}
